"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AutoCompleteInput = _interopRequireDefault(require("../common/AutoCompleteInput"));

var _FloatingLabelInput = _interopRequireDefault(require("../common/FloatingLabelInput"));

var _VerificationCodeInput = _interopRequireDefault(require("../common/VerificationCodeInput"));

var _PhoneNumberInput = _interopRequireDefault(require("../common/PhoneNumberInput"));

var _NeedMoblieNumberPopover = _interopRequireDefault(require("../need_mobile_number_popover/NeedMoblieNumberPopover"));

var _SignUpSuccessModal = _interopRequireDefault(require("../idc_signup_success_modal/SignUpSuccessModal"));

var _assetMapper = require("../../../../lib/assetMapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _window = window,
    text = _window.text,
    routes = _window.routes,
    url = _window.url,
    Logger = _window.Logger;
var _window2 = window,
    _ = _window2._;

var SignIn =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(SignIn, _Backbone$View);

  function SignIn(el, ozoneData, forwardUrl) {
    var _this;

    var formKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var errorMessage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var captchaRequired = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var showIdcSignUp = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var previousUsername = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';

    _classCallCheck(this, SignIn);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignIn).apply(this, arguments));
    _this.el = el;
    _this.ozoneData = ozoneData;
    _this.forms = ozoneData.forms;
    _this.features = ozoneData.features;
    _this.forwardUrl = forwardUrl;
    _this.formKey = formKey || window.Cookies.get('ozonePreferedIls');
    _this.errorMessage = errorMessage;
    _this.captcha = !!captchaRequired && ozoneData.captcha;
    _this.showIdcSignUp = showIdcSignUp === 'true';
    _this.idcOptions = ozoneData.getACard;
    _this.previousUsername = previousUsername;
    _this.idcOnly = window.featureManager.isEnabled('idc-only-ils') && _this.forms.length === 0 && _this.idcOptions;
    return _this;
  }

  _createClass(SignIn, [{
    key: "_render",
    value: function _render() {
      if (this.showIdcSignUp && this.ozoneData.getACard) {
        this.showIdcSignUp = false;

        this._renderIdcSignup();
      } else {
        this.el.empty().append(this._mainFormHtml());
        this.signInHeader = this.el.find('.signInHeader');
        this.inputContainer = this.el.find('.inputContainer');
        this.bottomSignInOptionsDiv = this.el.find('.bottomSignInOptionsContainer');

        this._renderLibraryCardForm();
      }

      if (this.idcOnly) {
        this._renderMobileNumberForm();
      }
    }
  }, {
    key: "_mainFormHtml",
    value: function _mainFormHtml() {
      var _this2 = this;

      var template = $("\n            <div class=\"signInHeader\">\n                <h1 class=\"headerText primary-color\">".concat(text("signInPage.welcome"), "</h1>\n                <p class=\"pleaseSignIn\">").concat(text("signInPage.pleaseSignIn"), "</p>\n                ").concat(this.ozoneData.getACard && this.ozoneData.getACard.primary.signUp ? "\n                    <div class=\"getACardPromo\">\n                        <p>".concat(text('signInPage.memberYet'), " <a class=\"secondary-color getOneInstantlyLink\" tabindex=\"0\">").concat(text('signInPage.getACard'), "</a></p>\n                    </div>\n                ") : '', "\n            </div>\n            <div class=\"inputContainer\"></div>\n            <div class=\"bottomSignInOptionsContainer\"></div>\n        "));
      template.find('.getOneInstantlyLink').on('click', function () {
        _this2._renderIdcSignup();
      });
      return template;
    }
  }, {
    key: "_renderLibraryCardForm",
    value: function _renderLibraryCardForm() {
      var _this3 = this;

      this.inputContainer.empty();
      var libraryCardSignInContaniner = $('<div class="LibraryCardSignIn"></div>');
      var selectedForm;

      if (this.formKey) {
        selectedForm = this.forms.find(function (f) {
          return f.ilsName === _this3.formKey;
        });

        if (selectedForm) {
          this._renderSubForm(selectedForm, libraryCardSignInContaniner);
        }
      }

      if (this.forms.length === 1) {
        this._renderSubForm(this.forms[0], libraryCardSignInContaniner);
      } else {
        new _AutoCompleteInput["default"]({
          el: this.inputContainer,
          className: 'signInInput',
          id: 'signin-options',
          label: text('signInPage.libraryCard.branches'),
          fieldList: this.forms.map(function (f) {
            return f.displayName;
          }),
          defaultField: selectedForm && selectedForm.displayName,
          selectedEvent: function selectedEvent(branchKey) {
            selectedForm = _this3.forms.find(function (f) {
              return f.displayName === branchKey;
            });
            var millisecondsInYear = 1000 * 60 * 60 * 24 * 365;
            var expireDate = new Date(Date.now() + millisecondsInYear);
            window.Cookies.set('ozonePreferedIls', selectedForm.ilsName, {
              httpOnly: false,
              expires: expireDate
            });

            _this3._renderSubForm(selectedForm, libraryCardSignInContaniner);
          }
        }).render();
      }

      this.inputContainer.append(libraryCardSignInContaniner);

      if (this.errorMessage) {
        this._showErrorMessage(this.errorMessage);

        if (this.previousUsername !== '') {
          $("#username").focus();
          $("#username").val(this.previousUsername);
        }
      } // Prevent rendering the mobileNumber form if movedSiteMessage is enabled AND the form is of type "Moved"


      if (this.ozoneData.getACard && !(window.featureManager.isEnabled('movedSiteMessage') && selectedForm && selectedForm.type === "Moved")) {
        this._addSecondarySignIn('mobileNumber');
      }

      this._updateGetOneInstantlyButton(true);

      this.el.focus();
    }
  }, {
    key: "_renderSubForm",
    value: function _renderSubForm(selectedForm, container) {
      var _this4 = this;

      container.empty();

      if (window.featureManager.isEnabled('movedSiteMessage') && this.signInHeader.css('display') === 'none') {
        this.signInHeader.show();
      }

      if (window.featureManager.isEnabled('movedSiteMessage') && selectedForm.type === 'Moved') {
        this._renderMovedAccountMessage(selectedForm, container);

        return;
      }

      var inputs;

      if (selectedForm.type === 'External') {
        inputs = $("\n                <div class=\"ExternalSignInTextContainer\">\n                    <p>".concat(text('signInPage.libraryCard.externalSignIn'), "</p>\n                </div>\n            "));
      } else if (selectedForm.type === 'EmailRegistration') {
        this._renderEmailRegistration(selectedForm, container);

        return;
      } else {
        inputs = $('<div></div>');

        if (selectedForm.local.username.enabled) {
          inputs.append("\n                    <div class=\"usernameContainer\"></div>\n                    ".concat(!!selectedForm.loginHintUrl ? "\n                        <div class=\"helpLinkContainer\">\n                            <a class=\"helpLink\" href=\"".concat(selectedForm.loginHintUrl, "\" target=\"_blank\">\n                                ").concat(text('signInPage.helpLink', {
            fieldName: text("signInPage.usernameKeys.".concat(selectedForm.local.username.key || 'CardNumber'))
          }), "\n                            </a>\n                        </div>\n                    ") : '', "\n                "));
        }

        if (selectedForm.local.password.enabled) {
          inputs.append("\n                    <div class=\"passwordContainer\"></div>\n                    ".concat(!!selectedForm.pinHelpUrl ? "\n                        <div class=\"helpLinkContainer\">\n                            <a class=\"helpLink\" href=\"".concat(selectedForm.pinHelpUrl, "\" target=\"_blank\">\n                                ").concat(text('signInPage.helpLink', {
            fieldName: text("signInPage.usernameKeys.".concat(selectedForm.local.password.key || 'PIN'))
          }), "\n                            </a>\n                        </div>\n                    ") : '', "\n                "));
        }
      }

      var template = $("\n            <form name=\"login-form\" id=\"login-form\" method=\"post\" action=\"".concat(window.url(routes.ozone.authenticate, {
        forwardUrl: this.forwardUrl
      }), "\">\n                <input type=\"hidden\" name=\"ilsName\" value=\"").concat(selectedForm.ilsName, "\">\n                <input type=\"hidden\" name=\"authType\" value=\"").concat(selectedForm.type, "\">\n                ").concat(inputs.html(), "\n                ").concat(this.captcha ? "\n                    <div class=\"g-recaptcha\" data-sitekey=\"".concat(this.captcha.key, "\"></div>\n                ") : '', "\n                <div class=\"buttonsContainer\">\n                    <button class=\"signin-button button secondary\">\n                        <span>").concat(text('signIn'), "</span>\n                    </button>\n                </div>\n            </form>\n        "));
      container.append(template);
      this.username = undefined;
      this.password = undefined;

      if (selectedForm.type === 'Local' && selectedForm.local.username.enabled) {
        this.username = new _FloatingLabelInput["default"]({
          el: template.find('.usernameContainer'),
          className: 'signInInput',
          id: 'username',
          // replace spaces with non-breaking spaces to prevent Safari from interpreting the "card number" field as a credit card input
          label: text("signInPage.usernameKeys.".concat(selectedForm.local.username.key || 'CardNumber')).replace('\x20', '\xa0'),
          autocompleteHint: 'username'
        }).render();
      }

      if (selectedForm.type === 'Local' && selectedForm.local.password.enabled) {
        this.password = new _FloatingLabelInput["default"]({
          el: template.find('.passwordContainer'),
          className: 'signInInput',
          id: 'password',
          label: text("signInPage.pinKeys.".concat(selectedForm.local.password.key || 'PIN')),
          type: 'password',
          autocompleteHint: 'current-password'
        }).render();
      }

      template.find('.signInInput input').on('keypress', function (e) {
        if (e.which === 13) {
          e.preventDefault();

          _this4._submit();
        }
      });
      template.find(".signin-button").on('click', function (e) {
        e.preventDefault();

        if (selectedForm.type === 'External') {
          window.globalEvents.trigger('signIn:external', selectedForm.displayName);
        } else {
          window.globalEvents.trigger('signIn:library', selectedForm.displayName);
        }

        _this4._submit();
      }); // Prevent rendering the mobileNumber form if movedSiteMessage is enabled AND the form is of type "Moved"

      if (this.ozoneData.getACard && !(window.featureManager.isEnabled('movedSiteMessage') && selectedForm && selectedForm.type === "Moved")) {
        this._addSecondarySignIn('mobileNumber');
      }
    }
  }, {
    key: "_submit",
    value: function _submit() {
      var validUsername = !this.username || this.username.validateNonEmpty();
      var validPassword = !this.password || this.password.validateNonEmpty();

      if (validUsername && validPassword) {
        this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
        this.el.find('#login-form').submit();
      }
    }
  }, {
    key: "_renderMovedAccountMessage",
    value: function _renderMovedAccountMessage(account, container) {
      container.empty();
      this.signInHeader.hide();
      this.bottomSignInOptionsDiv.empty();
      var messageLink = "<a class=\"helpLink\" href=\"https://link.overdrive.com?websiteId=".concat(account.moved.websiteId, "&app=lightning\" target=\"_blank\">\n                            ").concat(text("signInPage.accountMovedLink"), "\n                            </a>");
      var message = text("signInPage.accountMoved", {
        accountLink: messageLink
      });
      var accessMessage = text("signInPage.accountMovedAccess");
      var template = $("\n            <p>".concat(message, "</p>\n            <p>").concat(accessMessage, "</p>\n        "));
      container.append(template);
    }
  }, {
    key: "_renderMobileNumberForm",
    value: function _renderMobileNumberForm() {
      var _this5 = this;

      this.inputContainer.empty();
      this.el.find('.errorMessage').remove();
      var template = $("\n            <div class=\"MobileSignIn\">\n                <div class=\"mobileNumberContainer\"></div>\n                <div class=\"verificationCodeText\">\n                    <p>".concat(text('signInPage.mobile.textVerificationCode'), "</p>\n                    <p>").concat(text('signInPage.mobile.ratesMayApply'), "</p>\n                </div>\n                <div class=\"buttonsContainer\">\n                    <button class=\"signin-button button secondary\">\n                        <span>").concat(text('signInPage.mobile.sendCode'), "</span>\n                    </button>\n                </div>\n            </div>\n        "));
      var numberInput = new _PhoneNumberInput["default"]({
        el: template.find('.mobileNumberContainer'),
        className: 'signInInput',
        id: 'mobileNumber',
        label: text('signInPage.mobile.mobileNumber'),
        type: 'tel',
        allowAllCountries: !this.idcOptions.primary.phoneCountryCodes,
        allowedCountries: this.idcOptions.primary.phoneCountryCodes
      }).render();
      this.inputContainer.append(template);

      this._addSecondarySignIn('libraryCard');

      this.idcOnly ? this._updateGetOneInstantlyButton(true) : this._updateGetOneInstantlyButton(false);
      this.el.focus();
      template.find('.signin-button').on('click', function () {
        _this5._sendCode(numberInput);
      });
      template.find('.signInInput input').on('keypress', this._getMobileNumberKeypressHandler(numberInput));
    }
  }, {
    key: "_addSecondarySignIn",
    value: function _addSecondarySignIn(type) {
      var _this6 = this;

      this.bottomSignInOptionsDiv.empty();

      if (this.idcOnly) {
        return;
      }

      var mainTemplate = $("\n            <div class=\"signInWith\">".concat(text('signInPage.or'), "</div>\n            <div class=\"OptionsContainer buttonsContainer\">\n                <button class=\"optionButton button\">\n                   ").concat(type === 'mobileNumber' ? "\n                        <img class=\"optionImage\" alt='".concat(text('signInPage.mobile.usingMobileNumber'), "' src='").concat((0, _assetMapper.toStaticUrl)('img/phone-icon.svg'), "'/>\n                         <p>").concat(text('signInPage.mobile.usingMobileNumber'), "</p>\n                    ") : "\n                        <img class=\"optionImage\" alt='".concat(text('signInPage.libraryCard.card'), "' src='").concat((0, _assetMapper.toStaticUrl)('img/library-card-icon.svg'), " '/>\n                        <p>").concat(text('signInPage.libraryCard.card'), "</p>\n                    "), "\n                </button>\n            </div>\n        "));
      this.bottomSignInOptionsDiv.append(mainTemplate);
      this.bottomSignInOptionsDiv.find('.optionButton').click(function () {
        if (type === 'mobileNumber') {
          _this6._renderMobileNumberForm();
        } else {
          _this6._renderLibraryCardForm();
        }
      });
    }
  }, {
    key: "_updateGetOneInstantlyButton",
    value: function _updateGetOneInstantlyButton(isDefault) {
      var _this7 = this;

      var container = $('.getACardPromoHeader');
      var label = container.find('p');
      var button = $('.getOneInstantly');

      if (featureManager.isEnabled('idcDuplicateHandlerFix')) {
        button.unbind('click');
      }

      if (isDefault) {
        label.html(text('signInPage.memberYet'));
        $('.button.getOneInstantly').html("<span>".concat(text('signInPage.getACardButton'), "</span>"));
        button.on('click', function () {
          _this7._renderIdcSignup();
        });
      } else {
        label.html(text('signInPage.alreadyMember'));
        $('.button.getOneInstantly').html("<span>".concat(text('signIn'), "</span>"));
        button.on('click', function () {
          _this7._render();
        });
      }
    }
  }, {
    key: "_renderVerificationCodeInput",
    value: function _renderVerificationCodeInput(phoneNumber, idcResponse) {
      var _this8 = this;

      this.el.empty();
      var template = $("\n            <div class=\"VerificationCodeContainer\">\n                <h1 class=\"verifyHeaderText primary-color\">".concat(text('signInPage.verifyYourNumber'), "</h1>\n                <p class=\"verifySubHeading\">").concat(text('signInPage.enterTheCode', {
        location: phoneNumber
      }), "</p>\n                <div class=\"verificationInputContainer inputContainer\"></div>\n                <p class=\"noCode\">").concat(text('signInPage.noCodeHtml', {
        resend: "<a tabindex=\"0\" role=\"button\" class=\"resendNow secondary-color\">".concat(text('signInPage.resendNow'), "</a>")
      }), "</p>\n                <p>").concat(text('signInPage.mobile.ratesMayApply'), "</p>\n                 <button class=\"signin-button button secondary\" style=\"width: 96%\">\n                    <span>").concat(text('signInPage.verify'), "</span>\n                </button>\n            </div>\n        "));
      var codeInput = new _VerificationCodeInput["default"]({
        el: template.find('.verificationInputContainer'),
        className: 'verificationCode',
        id: 'verificationCode',
        label: text("signInPage.enterTheCode", {
          location: phoneNumber
        })
      }).render();
      this.el.append(template);
      codeInput.focus();
      template.find('.resendNow').on('click', function () {
        _this8._resendCode(phoneNumber);
      });
      template.find('.signin-button').on('click', function () {
        _this8._verifyCode(codeInput, idcResponse);
      });
      template.find('.verificationCode input').on('keypress', function (e) {
        if (e.which === 13) {
          e.preventDefault();

          _this8._verifyCode(codeInput, idcResponse);
        }
      });
    }
  }, {
    key: "_renderEmailVerificationCodeInput",
    value: function _renderEmailVerificationCodeInput(email, idcResponse, ilsName) {
      var _this9 = this;

      this.el.empty();
      var template = $("\n            <div class=\"VerificationCodeContainer\">\n                <h1 class=\"verifyHeaderText primary-color\">".concat(text('signInPage.verifyYourEmail'), "</h1>\n                <p class=\"verifySubHeading\">").concat(text('signInPage.enterTheCode', {
        location: email
      }), "</p>\n                <div class=\"verificationInputContainer inputContainer\"></div>\n                <p class=\"noCode\">").concat(text('signInPage.noCodeHtml', {
        resend: "<a tabindex=\"0\" role=\"button\" class=\"resendNow secondary-color\">".concat(text('signInPage.resendNow'), "</a>")
      }), "</p>\n                 <button class=\"signin-button button secondary\" style=\"width: 96%\">\n                    <span>").concat(text('signInPage.verify'), "</span>\n                </button>\n            </div>\n        "));
      var codeInput = new _VerificationCodeInput["default"]({
        el: template.find('.verificationInputContainer'),
        className: 'verificationCode',
        id: 'verificationCode',
        label: text("signInPage.enterTheCode", {
          location: email
        })
      }).render();
      this.el.append(template);
      codeInput.focus();
      template.find('.resendNow').on('click', function () {
        _this9._resendEmailCode(email, ilsName);
      });
      template.find('.signin-button').on('click', function () {
        _this9._emailVerifyCode(codeInput, idcResponse, ilsName);
      });
      template.find('.verificationCode input').on('keypress', function (e) {
        if (e.which === 13) {
          e.preventDefault();

          _this9._emailVerifyCode(codeInput, idcResponse, ilsName);
        }
      });
    }
  }, {
    key: "_getMobileNumberKeypressHandler",
    value: function _getMobileNumberKeypressHandler(mobileNumberInput) {
      var _this10 = this;

      if (!mobileNumberInput) {
        throw new Error('you must pass "mobileNumberInput"');
      }

      return function (e) {
        if (e.which === 13) {
          e.preventDefault();

          _this10._sendCode(mobileNumberInput);
        }
      };
    }
  }, {
    key: "_renderIdcSignup",
    value: function _renderIdcSignup() {
      var _this11 = this;

      this.el.empty();
      var template = $("\n            <div class=\"IdcSignupContainer\">\n                <h1 class=\"IdcHeaderText primary-color\">".concat(text('getCard.noLibraryCard'), "</h1>\n                <h1 class=\"IdcHeaderText2 primary-color\">").concat(text('getCard.noProblem'), "</h1>\n                <p class=\"IdcSubHeading\">").concat(text('getCard.takesAFewSec'), "</p>\n                <a class=\"whyDoYouNeed secondary-color\" role=\"button\" tabindex=\"0\">").concat(text('getCard.whyDoYouNeed'), "</a>\n                <p class=\"alreadyHaveCardHtml\">").concat(text('signInPage.idc.alreadyHaveCardHtml'), "</p>\n                <div class=\"IdcInputContainer inputContainer\">\n                    <div class=\"mobileNumberContainer\"></div>\n                    <div class=\"verificationCodeText\">\n                        <p>").concat(text('signInPage.mobile.textVerificationCode'), "</p>\n                        <p>").concat(text('signInPage.mobile.ratesMayApply'), "</p>\n                    </div>\n                    <div class=\"buttonsContainer\">\n                        <button class=\"signin-button button secondary\">\n                            <span>").concat(text('signInPage.mobile.sendCode'), "</span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        "));
      var numberInput = new _PhoneNumberInput["default"]({
        el: template.find('.mobileNumberContainer'),
        className: 'signInInput',
        id: 'mobileNumber',
        label: text('signInPage.mobile.mobileNumber'),
        type: 'tel',
        allowAllCountries: !this.idcOptions.primary.phoneCountryCodes,
        allowedCountries: this.idcOptions.primary.phoneCountryCodes
      }).render();
      new _NeedMoblieNumberPopover["default"](template.find('.whyDoYouNeed')).render();
      this.el.append(template);

      this._updateGetOneInstantlyButton(false);

      this.el.focus();
      template.find('.signin-button').on('click', function () {
        _this11._sendCode(numberInput);
      });
      template.find('.signInInput input').on('keypress', this._getMobileNumberKeypressHandler(numberInput));
    }
  }, {
    key: "_renderIdcAdditionalInfo",
    value: function _renderIdcAdditionalInfo(idcResponse) {
      var _this12 = this;

      this.el.empty();
      var signUpOptions = idcResponse.signUpOptions[0];
      var requiredFields = signUpOptions.requiredFields.filter(function (field) {
        return field !== 'PhoneToken' && field !== 'IpAddress';
      });
      var optionalFields = signUpOptions.optionalFields;
      var fields = $('<div></div>');
      requiredFields.forEach(function (field) {
        fields.append("<div class=\"".concat(field, "Container\"></div>"));
      });
      optionalFields.forEach(function (field) {
        fields.append("<div class=\"".concat(field, "Container\"></div>"));
      });
      var terms = "<a href=\"https://company.cdn.overdrive.com/policies/terms-and-conditions.htm\" class=\"secondary-color\" target=\"_blank\">".concat(text('signInPage.idc.termsAndConditions'), "</a>");
      var policy = "<a href=\"https://company.cdn.overdrive.com/policies/privacy-policy.htm\" class=\"secondary-color\" target=\"_blank\">".concat(text('signInPage.idc.privacyPolicy'), "</a>");
      var template = $("\n            <div class=\"IdcAdditonalInfoContainer\">\n                <h1 class=\"IdcAdditionalHeaderText primary-color\">".concat(text('signInPage.idc.completeVerification'), "</h1>\n                 <p class=\"IdcAdditionalSubHeading\">").concat(text('signInPage.idc.fewMoreThings'), "</p>\n                 <div class=\"inputContainer\">\n                    ").concat(fields.html(), "\n                 </div>\n                 <p class=\"bySelectingContinue\">").concat(text('signInPage.idc.bySelectingContinue'), "</p>\n                 <ul>\n                    <li>").concat(text('signInPage.idc.13OrOlder'), "</li>\n                    <li>").concat(text('signInPage.idc.youAgreeHtml', {
        terms: terms,
        policy: policy
      }), "</li>\n                </ul>\n                <div class=\"buttonsContainer\">\n                    <button class=\"signin-button button secondary\">\n                        <span>").concat(text('signInPage.idc.continue'), "</span>\n                    </button>\n                </div>\n                <div class=\"weRespectPrivacyContainer\">\n                    <img class=\"privacyIcon\" alt='").concat(text('signInPage.idc.weRespectPrivacy'), "' src='").concat((0, _assetMapper.toStaticUrl)('img/privacy-icon.svg'), "'/>\n                    <p class=\"weRespectPrivacy\">").concat(text('signInPage.idc.weRespectPrivacy'), "</p>\n                </div>\n            </div>\n        "));
      var requiredFieldInputs = [];
      requiredFields.forEach(function (field) {
        requiredFieldInputs.push(new _FloatingLabelInput["default"]({
          el: template.find(".".concat(field, "Container")),
          className: 'signInInput requiredField',
          id: field,
          label: text('signInPage.idc.' + field),
          type: 'text'
        }).render());
      });
      var optionalFieldInputs = [];
      optionalFields.forEach(function (field) {
        optionalFieldInputs.push(new _FloatingLabelInput["default"]({
          el: template.find(".".concat(field, "Container")),
          className: 'signInInput',
          id: field,
          label: text('signInPage.optionalField', {
            fieldName: text('signInPage.idc.' + field)
          }),
          type: 'text'
        }).render());
      });
      this.el.append(template);
      this.el.focus();
      template.find('.signin-button').on('click', function () {
        _this12._signUp(requiredFieldInputs, optionalFieldInputs, idcResponse);
      });
      template.find('.signInInput input').on('keypress', function (e) {
        if (e.which === 13) {
          e.preventDefault();

          _this12._signUp(requiredFieldInputs, optionalFieldInputs, idcResponse);
        }
      });
    }
  }, {
    key: "_renderIdcDenied",
    value: function _renderIdcDenied() {
      var _this13 = this;

      this.el.empty();
      var template = $("\n            <div class=\"IdcAdditonalInfoContainer\">\n                <h1 class=\"IdcAdditionalHeaderText primary-color\">".concat(text('signInPage.idc.unableToConfirm'), "</h1>\n                 <p class=\"weCouldntGrant\">").concat(text('signInPage.idc.weCouldntGrant'), "</p>\n                 <p class=\"youMayBeEligible\">").concat(text('signInPage.idc.youMayBeEligible'), "\n                    ").concat(!!window.OverDrive.cardSignUpLink ? "\n                        <a href=\"".concat(window.OverDrive.cardSignUpLink, "\" class=\"secondary-color\"  target=\"_blank\">").concat(text('signInPage.idc.learnMore'), "</a>\n                    ") : '', "\n                </p>\n                <div class=\"buttonsContainer\">\n                    <button class=\"signin-button button secondary\">\n                        <span>").concat(text('signInPage.idc.goBack'), "</span>\n                    </button>\n                </div>\n            </div>\n        "));
      this.el.append(template);
      this.el.focus();
      template.find('.signin-button').on('click', function () {
        _this13._render();
      });
    }
  }, {
    key: "_renderEmailRegistration",
    value: function _renderEmailRegistration(selectedForm, container) {
      var _this14 = this;

      this.el.find('.errorMessage').remove();
      var template = $("\n            <div class=\"EmailSignIn\">\n                <div class=\"emailContainer\"></div>\n                <div class=\"verificationCodeText\">\n                    <p>".concat(text('signInPage.emailVerificationCode'), "</p>\n                </div>\n                <div class=\"buttonsContainer\">\n                    <button class=\"signin-button button secondary\">\n                        <span>").concat(text('signInPage.mobile.sendCode'), "</span>\n                    </button>\n                </div>\n            </div>\n        "));
      var emailInput = new _FloatingLabelInput["default"]({
        el: template.find('.emailContainer'),
        className: 'signInInput',
        id: 'email',
        label: text('signInPage.idc.Email'),
        type: 'text'
      }).render();
      container.append(template);

      if (this.ozoneData.forms.length > 1) {
        this._addSecondarySignIn('libraryCard');
      }

      this.el.focus();
      template.find('.signin-button').on('click', function () {
        _this14._checkValidEmail(emailInput, selectedForm.ilsName);
      });
      template.find('.signInInput input').on('keypress', function (e) {
        if (e.which === 13) {
          e.preventDefault();

          _this14._checkValidEmail(emailInput, selectedForm.ilsName);
        }
      });
    }
  }, {
    key: "_signUp",
    value: function _signUp(requiredFieldInputs, optionalFieldInputs, idcResponse) {
      var _this15 = this;

      var valid = true;
      requiredFieldInputs.forEach(function (input) {
        if (!input.validateNonEmpty()) {
          valid = false;
        }
      });

      if (valid) {
        this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
        var userData = {};
        requiredFieldInputs.forEach(function (input) {
          userData[input.$input.attr('id')] = input.$input.val();
        });
        optionalFieldInputs.forEach(function (input) {
          userData[input.$input.attr('id')] = input.$input.val();
        });
        userData.PhoneToken = idcResponse.token;
        $.post(window.url(window.routes.rest.idc.signUp), {
          userData: JSON.stringify(userData),
          ilsName: this.ozoneData.getACard.primary.ilsName
        }).done(function (response) {
          var successModal = new _SignUpSuccessModal["default"]();
          window.globalEvents.trigger('signIn:mobileNum', window.OverDrive.libraryName);
          successModal.on('close', function () {
            _this15._idcSignIn(response);
          });
        }).fail(function (err) {
          _this15.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

          if (err.responseJSON.error.statusCode && err.responseJSON.error.statusCode === 'Denied') {
            Logger.log('error', 'IDC sign-up step, user was denied', {
              message: err.responseText
            });

            _this15._renderIdcDenied();
          } else {
            Logger.log('error', 'IDC sign-up step failed', {
              message: err.responseText
            });

            _this15._showErrorMessage(text('signInPage.idc.signUpError', {
              link: "<a href=\"".concat(window.OverDrive.cardSignUpLink, "\">").concat(text("signInPage.idc.contactLibrary"), "</a>")
            }));
          }
        });
      }
    }
  }, {
    key: "_sendCode",
    value: function _sendCode(phoneNumberInput) {
      var _this16 = this;

      if (phoneNumberInput.validate()) {
        this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
        $.post(window.url(window.routes.rest.idc.phone.sendCode), {
          phoneNumber: phoneNumberInput.E164
        }).done(function (response) {
          window.globalEvents.trigger('mobile:register:code:sent');
          window.globalEvents.trigger('mobile:code:sent', window.OverDrive.libraryName);

          _this16._renderVerificationCodeInput(phoneNumberInput.displayValue, response);
        }).fail(function (err) {
          _this16.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

          Logger.log('error', 'Send IDC code to phone failed', {
            message: err.responseText
          });

          _this16._showErrorMessage(text('signInPage.idc.errorSendingCode'));
        });
      }
    }
  }, {
    key: "_resendCode",
    value: function _resendCode(phoneNumber) {
      var _this17 = this;

      $.post(window.url(window.routes.rest.idc.phone.sendCode), {
        phoneNumber: phoneNumber
      }).done(function (response) {
        window.globalEvents.trigger('mobile:code:resent', window.OverDrive.libraryName);
        window.globalEvents.trigger('mobile:register:code:resent');

        _this17._showCodeResentMessage();
      }).fail(function (err) {
        Logger.log('error', 'Send IDC code to phone failed', {
          message: err.responseText
        });

        _this17._showErrorMessage(text('signInPage.idc.errorSendingCode'));
      });
    }
  }, {
    key: "_verifyCode",
    value: function _verifyCode(codeInput, idcResponse) {
      var _this18 = this;

      if (codeInput.validate()) {
        window.globalEvents.trigger('mobile:code:verified', window.OverDrive.libraryName);
        window.globalEvents.trigger('mobile:register:code:verified');
        this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
        $.post(window.url(window.routes.rest.idc.phone.verifyCode), {
          code: codeInput.$input.val(),
          phoneE164: idcResponse.phoneE164,
          ilsName: this.ozoneData.getACard.primary.ilsName
        }).done(function (response) {
          if (response.status === 'SignInAvailable') {
            window.globalEvents.trigger('mobile:register:submit');

            _this18._idcSignIn(response);
          } else if (response.status === 'SignUpAvailable') {
            _this18._renderIdcAdditionalInfo(response);
          } else {
            console.log(response);
          }
        }).fail(function (err) {
          if (featureManager.isEnabled('declineNewIdcLogin') && !_this18.ozoneData.getACard.primary.signUp && err.status === 400 && err.responseJSON.error.status === "Unavailable") {
            _this18._render();

            _this18._renderMobileNumberForm();

            _this18._showErrorMessage(text('signInPage.idc.numberNotKnown'));
          } else {
            _this18.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

            Logger.log('error', 'Failed to verify IDC code', {
              message: err.responseText
            });

            _this18._showErrorMessage(text('signInPage.idc.errorSendingCode'));
          }
        });
      }
    }
  }, {
    key: "_checkValidEmail",
    value: function _checkValidEmail(emailInput, ilsName) {
      var _this19 = this;

      if (emailInput.validateNonEmpty()) {
        this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
        var userData = {
          Email: emailInput.$input.val()
        };
        $.post(window.url(window.routes.rest.idc.signUp), {
          userData: JSON.stringify(userData),
          ilsName: ilsName
        }).done(function (response) {
          window.globalEvents.trigger('signIn.email', ilsName);

          _this19._idcSignIn(response);
        }).fail(function (err) {
          _this19.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

          if (err.responseJSON.error.statusCode && err.responseJSON.error.statusCode === 'Denied') {
            Logger.log('error', 'IDC email was not valid', {
              message: err.responseText
            });

            _this19._showErrorMessage(text('signInPage.emailIneligible'));
          } else if (err.responseJSON.error.requiredFields && err.responseJSON.error.requiredFields.includes('EmailToken')) {
            _this19._emailSendCode(emailInput, ilsName);
          } else {
            Logger.log('error', 'IDC check valid email step failed', {
              message: err.responseText
            });

            _this19._showErrorMessage(text('signInPage.email.validationError'));
          }
        });
      }
    }
  }, {
    key: "_emailSignUp",
    value: function _emailSignUp(ilsName, idcResponse) {
      var _this20 = this;

      this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
      var userData = {
        Email: idcResponse.email,
        EmailToken: idcResponse.emailToken
      };
      $.post(window.url(window.routes.rest.idc.signUp), {
        userData: JSON.stringify(userData),
        ilsName: ilsName
      }).done(function (response) {
        _this20._idcSignIn(response);
      }).fail(function (err) {
        _this20.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

        Logger.log('error', 'IDC email sign-up failed', {
          message: err.responseText
        });

        _this20._showErrorMessage(text('signInPage.idc.signUpError', {
          link: "<a href=\"".concat(window.OverDrive.cardSignUpLink, "\">").concat(text("signInPage.idc.contactLibrary"), "</a>")
        }));
      });
    }
  }, {
    key: "_emailSendCode",
    value: function _emailSendCode(emailInput, ilsName) {
      var _this21 = this;

      $.post(window.url(window.routes.rest.idc.email.sendCode), {
        emailAddress: emailInput.$input.val()
      }).done(function (response) {
        window.globalEvents.trigger('email:code:sent', ilsName);

        _this21._renderEmailVerificationCodeInput(emailInput.$input.val(), response, ilsName);
      }).fail(function (err) {
        _this21.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

        Logger.log('error', 'Send IDC code to email failed', {
          message: err.responseText
        });

        _this21._showErrorMessage(text('signInPage.idc.errorSendingCode'));
      });
    }
  }, {
    key: "_resendEmailCode",
    value: function _resendEmailCode(emailAddress) {
      var _this22 = this;

      $.post(window.url(window.routes.rest.idc.email.sendCode), {
        emailAddress: emailAddress
      }).done(function (response) {
        window.globalEvents.trigger('email:code:resent', window.OverDrive.libraryName);

        _this22._showCodeResentMessage();
      }).fail(function (err) {
        Logger.log('error', 'Send IDC code to email failed', {
          message: err.responseText
        });

        _this22._showErrorMessage(text('signInPage.idc.errorSendingCode'));
      });
    }
  }, {
    key: "_emailVerifyCode",
    value: function _emailVerifyCode(codeInput, idcResponse, ilsName) {
      var _this23 = this;

      if (codeInput.validate()) {
        window.globalEvents.trigger('email:code:verified', ilsName);
        this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
        $.post(window.url(window.routes.rest.idc.email.verifyCode), {
          code: codeInput.$input.val(),
          emailAddress: idcResponse.email,
          ilsName: ilsName
        }).done(function (response) {
          _this23._emailSignUp(ilsName, response);
        }).fail(function (err) {
          _this23.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

          Logger.log('error', 'Failed to verify IDC email code', {
            message: err.responseText
          });

          _this23._showErrorMessage(text('signInPage.idc.invalidVerify'));
        });
      }
    }
  }, {
    key: "_idcSignIn",
    value: function _idcSignIn(idcResponse) {
      var $form = $("\n            <form method=\"post\" action=\"".concat(url(routes.ozone.authenticate, {
        forwardUrl: this.forwardUrl
      }), "\">\n                <input type=\"hidden\" name=\"authType\" value=\"local\">\n                <input type=\"hidden\" name=\"ilsName\" value=\"").concat(idcResponse.signIn.ilsName, "\">\n                <input type=\"hidden\" name=\"username\" value=\"").concat(idcResponse.signIn.username, "\">\n                <input type=\"hidden\" name=\"password\" value=\"").concat(idcResponse.signIn.password, "\">\n            </form>\n        "));
      this.el.append($form);
      $form.submit();
    }
  }, {
    key: "_showErrorMessage",
    value: function _showErrorMessage(message) {
      var template = $("\n            <div class=\"errorMessage\">\n                <div class=\"errorIcon\">!</div>\n                <p>".concat(message, "</p>\n            </div>\n        "));
      this.el.find('.errorMessage').remove();
      this.el.find('.inputContainer').before(template);
    }
  }, {
    key: "_showCodeResentMessage",
    value: function _showCodeResentMessage() {
      var template = $("\n            <div class=\"codeResent\">\n                <p> ".concat(text("signInPage.idc.newCodeSent"), "\n                    <span class=\"js-saved Saved-container\">\n                        <span class=\"Saved\">\n                            <svg class=\"Saved-Checkmark\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 52 52\">\n                                <circle class=\"Saved-checkmarkCircle\" cx=\"26\" cy=\"26\" r=\"25\" fill=\"none\"></circle>\n                                <path class=\"Saved-checkmarkCheck\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\"></path>\n                            </svg>\n                        </span>\n                    </span>\n                </p>\n            </div>\n        "));
      this.el.find('.errorMessage').remove();
      this.el.find('.codeResent').remove();
      this.el.find('.inputContainer').before(template);
    }
  }]);

  return SignIn;
}(Backbone.View);

exports["default"] = SignIn;